import { ArrowRight, MessageCircle } from "lucide-react";
import { useEffect, useState } from "react";
import VesselTrafficMap from "./VesselTrafficMap";
import AirportTicker from "./AirportTicker";

const routes = [
  {
    commodity: "Polypropylene granules",
    origin: "Shanghai, China",
    destination: "Chennai, India",
  },
  { commodity: "Lithium ore", origin: "Tanzania", destination: "Osaka, Japan" },
  {
    commodity: "Basmati Rice",
    origin: "Mundra, India",
    destination: "Prague, Czech Republic",
  },
  { commodity: "Pet coke", origin: "Texas, USA", destination: "India" },
];

export default function HeroSection() {
  const [entered, setEntered] = useState(false);

  useEffect(() => {
    const id = requestAnimationFrame(() => setEntered(true));
    return () => cancelAnimationFrame(id);
  }, []);

  return (
    <section className="hero-stage relative overflow-hidden">
      <div className="hero-grid-bg absolute inset-0" />

      {/* Map as background layer, fading out behind the headline on the left */}
      <div
        className={`pointer-events-none absolute inset-y-0 right-0 z-0 w-full transition-opacity duration-1000 ease-out md:w-[78%] ${
          entered ? "opacity-100" : "opacity-0"
        }`}
      >
        <div className="map-bg-fade flex h-full items-center">
          <VesselTrafficMap />
        </div>
      </div>

      <div className="container relative z-10 px-4 pt-28 pb-14 md:pt-36 md:pb-24">
        <div
          className={`max-w-xl transition-all duration-1000 ease-out ${
            entered ? "opacity-100 translate-y-0" : "opacity-0 translate-y-3"
          }`}
        >
          <p className="mb-5 font-mono text-[11px] uppercase tracking-[0.28em] text-primary">
            Global commodity trade, in motion
          </p>
          <h1 className="font-display text-4xl font-medium leading-[1.06] tracking-[-0.02em] text-foreground md:text-6xl lg:text-[4rem]">
            Global procurement,
            <br />
            simplified
          </h1>
          <p className="mt-6 max-w-xl text-base leading-relaxed text-muted-foreground md:text-lg">
            Taram is an AI-powered procurement & logistics company. We train our
            models on historic trade data to source, negotiate, quality-check,
            to provide safe payment terms, and ship commodities across global
            supply chains.
          </p>
          <div className="mt-8 flex flex-wrap gap-3">
            <a
              href="#contact"
              className="inline-flex items-center gap-2 rounded-lg bg-primary px-6 py-3 text-sm font-medium text-primary-foreground transition-colors hover:bg-primary/90"
            >
              Get a Quote <ArrowRight className="h-4 w-4" />
            </a>
            <a
              href="#offices"
              className="inline-flex items-center gap-2 rounded-lg border border-border px-6 py-3 text-sm font-medium text-foreground transition-colors hover:bg-secondary"
            >
              <MessageCircle className="h-4 w-4" /> Speak to Us
            </a>
          </div>
        </div>

        {/* In transit ticker */}
        <div
          className={`mt-10 transition-opacity duration-1000 ease-out ${entered ? "opacity-100" : "opacity-0"}`}
        >
          <AirportTicker routes={routes} interval={4500} />
        </div>
      </div>
    </section>
  );
}
